// @flow
import * as React from 'react';
import { type GridPin } from 'app/packages/pinterest-flow-types/pin';
import {
  type SignupSourceType,
  type SignupTypesFlowType,
} from 'app/common/react/components/growth/unauth/signup/constants';

export type PinImageClickHandlerType = (event: SyntheticEvent<>, pin: GridPin) => void;
export type PinLinkClickHandlerType = () => void;
export type ShowSignupModalType = (
  type: SignupTypesFlowType,
  signupSource: SignupSourceType,
  container?: string,
  e?: SyntheticEvent<>,
) => void;
export type ShowSignupLoginModalType = (type: SignupTypesFlowType, dismissible: boolean) => void;
// $FlowFixMe Flow v0.104.0 upgrade supression.
export type showResponseModalSignupType = (responseType: string, responseModalPin: *) => void;

export type UnauthPageWrapperContextType = {
  pinImageClickHandler: PinImageClickHandlerType,
  pinLinkClickHandler: PinLinkClickHandlerType,
  showSignupLoginModal: ShowSignupLoginModalType,
  showSignupModal: ShowSignupModalType,
  showResponseModalSignup: showResponseModalSignupType,
};

const UnauthPageWrapperContextDefaultValue: UnauthPageWrapperContextType = {
  pinImageClickHandler: (event, pin) => {},
  pinLinkClickHandler: () => {},
  showSignupLoginModal: (type, dismissible) => {},
  showSignupModal: (type, signupSource) => {},
  showResponseModalSignup: (responseType, responseModalPin) => {},
};

// $FlowFixMe: new errors found from flow 0.96 upgrade
const UnauthPageWrapperContext = React.createContext(UnauthPageWrapperContextDefaultValue);

export default UnauthPageWrapperContext;
